import styled from '../../../consts/styled';
import { HStack } from '@chakra-ui/react';
import { colors, spacing } from '../../../App/ChakraTheme'; 

export const TabMenuContainer = styled(HStack)`
  margin: ${spacing.BASE} 0;
  position: relative;
  background: white;
  border: 2px solid ${colors.midnight};
  border-radius: 8px;
  padding: 12px 16px;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 300px;
  max-width: 400px;
  justify-content: space-between;
  align-items: center;

  &:hover {
    border-color: ${colors.persianblue};
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }

  & div.tab-menu-container {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    z-index: 1000;
    margin-top: 4px;
    transition: all 0.2s ease;
    transform-origin: top;
  }
  
  & div.tab-menu-container.hidden {
    opacity: 0;
    transform: scaleY(0);
    pointer-events: none;
  }
  
  & div.tab-menu-container.displayed {
    opacity: 1;
    transform: scaleY(1);
    pointer-events: all;
  }
  
  & svg {
    padding-left: ${spacing.TINY};
    cursor: pointer;
    transition: transform 0.2s ease;
    width: 30px;
    height: 30px;
    opacity: 0.8;
    
    &:hover {
      opacity: 1;
    }
  }
  
  & div.tab-menu-container.displayed svg {
    transform: rotate(180deg);
  }
  
  & .tab-caption {
    color: ${colors.midnight};
    font-weight: 600;
    font-size: 14px;
  }

  & svg g path:last-child {
    fill: ${colors.midnight};
  }

  & ul {
    padding: 0;
    margin: 0;
    width: 100%;
    min-width: 300px;
    max-width: 400px;
    max-height: 350px;
    background: white;
    border: 2px solid ${colors.midnight};
    border-radius: 8px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
    list-style: none;
    overflow-y: auto;
    overflow-x: hidden;
    
    /* Custom scrollbar styling */
    &::-webkit-scrollbar {
      width: 6px;
    }
    
    &::-webkit-scrollbar-track {
      background: #f1f1f1;
      border-radius: 3px;
    }
    
    &::-webkit-scrollbar-thumb {
      background: ${colors.midnight};
      border-radius: 3px;
    }
    
    &::-webkit-scrollbar-thumb:hover {
      background: ${colors.persianblue};
    }
  }

  & li {
    cursor: pointer;
    padding: 16px 20px;
    border-bottom: 1px solid #f0f0f0;
    transition: all 0.2s ease;
    background: white;
  }
  
  & li:last-child {
    border-bottom: none;
  }
  
  & li:hover {
    background-color: #f8f9fa;
    color: ${colors.persianblue};
  }
  
  & li.active {
    background-color: ${colors.persianblue};
    color: white;
  }
  
  & li.active:hover {
    background-color: ${colors.persianblue};
    color: white;
  }
  
  & li h5 {
    color: inherit;
    font-weight: 500;
    font-size: 14px;
    margin: 0;
  }
  
  & li.disabled {
    color: #adadad;
    cursor: not-allowed;
    background-color: #f8f9fa;
  }
  
  & li.disabled:hover {
    background-color: #f8f9fa;
    color: #adadad;
  }
`;
